import React, { useEffect, useState, useRef } from "react";
import { getNewTasksChartData } from "./api";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  BarChart,
} from "recharts";

const NewTasksChart = () => {
  const [range, setRange] = useState("1w");
  const [interval, setInterval] = useState("daily");
  const [data, setData] = useState(false);
  const [chartType, setChartType] = useState("bar"); //Line or Bar or Cumulative Line
  const [dimensions, setDimensions] = useState({ width: 0, height: 400 });
  const containerRef = useRef(null);

  Date.prototype.addHours = function (h) {
    this.setTime(this.getTime() + h * 60 * 60 * 1000);
    return this;
  };

  const getChartData = async (selectedRange, selectedInterval) => {
    const res = await getNewTasksChartData(selectedRange, selectedInterval);
    console.log(res)
    setData(res.count);  // Changed from res.new_users to res.new_tasks
  };

  useEffect(() => {
    getChartData(range, interval);
  }, [range]); // Only re-fetch when range changes

  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        setDimensions({ width: width, height: Math.min(400, width * 0.6) });
      }
    };

    window.addEventListener('resize', updateDimensions);
    updateDimensions();
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    date.setHours(date.getHours() + 2); // Keep the +2 hours adjustment
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}`;
  };

  return (
    <div ref={containerRef}>
      <div className="mt-4 is-flex is-justify-content-space-between">
        <h1 className="title is-5 has-text-center">New Courses</h1>
        <div>
          <div className="select is-grey is-hidden-mobile" >
            <select onChange={(e) => setRange(e.target.value)} value={range}>
              <option>1d</option>
              <option>3d</option>
              <option>1w</option>
              <option>2w</option>
              <option>1m</option>
              <option>3m</option>
              <option>6m</option>
              <option>1y</option>
            </select>
          </div>
          <div className="select is-grey ml-5 is-hidden-mobile">
            <select onChange={(e) => setInterval(e.target.value)} value={interval}>
              {/* <option>hourly</option> */}
              <option>daily</option>
              <option>weekly</option>
              <option>monthly</option>
            </select>
          </div>
          <div className="select is-grey ml-5 is-hidden-mobile">
            <select onChange={(e) => setChartType(e.target.value)}  value={chartType}>
              <option>line</option>
              <option>bar</option>
              <option>cumulative</option>
            </select>
          </div>
        </div>
      </div>
      <div className="chart">
        {data && chartType === "line" ? (
          <div>
            <LineChart
              width={dimensions.width}
              height={dimensions.height}
              data={Object.entries(data).map(([timestamp, count]) => ({
                timestamp: formatDate(timestamp),
                count: parseInt(count),
              }))}>
              <XAxis dataKey="timestamp" />
              <YAxis />
              <Tooltip />
              {chartType === "line" && (
                <Line type="monotone" dataKey="count" strokeWidth={4} />
              )}
              {/* Add other chart types based on user selection */}
            </LineChart>
          </div>
        ) : data && chartType === "cumulative" ? (
          <div>
            <LineChart
              width={dimensions.width}
              height={dimensions.height}
              data={Object.entries(data).map(([timestamp, count], idx) => ({
                timestamp: formatDate(timestamp),
                count: Object.values(data)
                  .slice(0, idx + 1)
                  .reduce((a, b) => a + b),
              }))}>
              <XAxis dataKey="timestamp" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="count" strokeWidth={4} />
              {/* Add other chart types based on user selection */}
            </LineChart>
          </div>
        ) : data && chartType === "bar" ? (
          <div>
            <BarChart
              width={dimensions.width}
              height={dimensions.height}
              data={Object.entries(data).map(([timestamp, count]) => ({
                timestamp: formatDate(timestamp),
                count: parseInt(count),
              }))}>
              <Bar dataKey="count" fill="#7CA5A7" />

              <XAxis dataKey="timestamp" />
              <YAxis dataKey={"count"} />
              <Tooltip />
              {/* Add other chart types based on user selection */}
            </BarChart>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default NewTasksChart;
